<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑生产工单' : '新增生产工单'"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div>
        <e-form ref="refForm" :column="formColumn" :data.sync="selfData" />
        <div class="group-title m-t-20">工艺路线</div>
        <div class="m-t-10">工艺路线内容</div>
        <div class="group-title m-t-20">物料清单</div>
        <div class="m-t-10">物料清单内容</div>
        <div class="group-title m-t-20">工艺详情</div>
        <div class="m-t-10">工艺详情内容</div>
        <div class="group-title m-t-20">成品</div>
        <div class="m-t-10">成品内容</div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    billId: {
      type: [Number, String],
      default: ''
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        id: '',
        code: '',
        bill_code: '',
        you_xian_ji: '正常',
        ban_zu: '',
        che_jian: '',
        chan_xian: '',
        fu_ze_ren_id: '',
        dan_ju_date: '',
        ji_hua_date: '',
        shi_ji_date: '',
        she_bei_id: '',
        gong_yi_id: '',
        she_bei_name: '',
        gong_yi_name: ''
      },
      formColumn: [
        {
          type: 'text',
          title: '工单编码',
          field: 'code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          disabled: true
        },
        {
          type: 'select',
          title: '班组',
          field: 'ban_zu',
          options: []
        },
        {
          type: 'select',
          title: '车间',
          field: 'che_jian',
          options: []
        },
        {
          type: 'select',
          title: '产线',
          field: 'chan_xian',
          options: []
        },
        {
          type: 'select',
          title: '设备',
          field: 'she_bei_id',
          options: []
        },
        {
          type: 'select',
          title: '工艺',
          field: 'gong_yi_id',
          options: []
        },
        {
          type: 'select',
          title: '负责人',
          field: 'fu_ze_ren_id',
          options: []
        },
        {
          type: 'date',
          title: '单据日期',
          field: 'dan_ju_date'
        },
        {
          type: 'date',
          title: '计划日期',
          field: 'ji_hua_date'
        },
        {
          type: 'date',
          title: '实际交期',
          field: 'shi_ji_date'
        },
        {
          type: 'select',
          title: '优先级',
          field: 'you_xian_ji',
          options: [
            {
              key: '正常',
              val: '正常'
            },
            {
              key: '宽松',
              val: '宽松'
            },
            {
              key: '紧急',
              val: '紧急'
            },
            {
              key: '加急',
              val: '加急'
            }
          ]
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.getPmcData()
    }
    this.getBanZuList()
    this.getChejianList()
    this.getChanxianList()
    this.getYuangongList()
    this.getSheBeiListData()
    this.getGongyiList()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/shangchangongdan/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
    },
    // 获取pmc数据
    async getPmcData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/pmc/detail',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          console.log(result)
          this.selfData = result
        }
      })
    },
    // 获取班组列表
    getBanZuList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/banzu/list',
        data: {
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'ban_zu') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取车间列表
    getChejianList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '车间',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'che_jian') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取产线列表
    getChanxianList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '产线',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'chan_xian') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取员工列表
    getYuangongList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/yuanGong2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.yuan_gong_user_name,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'fu_ze_ren_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取设备列表
    getSheBeiListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/sheBei/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'she_bei_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取工艺列表
    getGongyiList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.mu_ban_ming_cheng,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'gong_yi_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      if (!this.selfData.fu_ze_ren_id) this.selfData.fu_ze_ren_name = ''
      if (!this.selfData.she_bei_id) this.selfData.she_bei_name = ''
      if (!this.selfData.gong_yi_id) this.selfData.gong_yi_name = ''
      this.$api({
        method: 'post',
        url: '/admin/gcvip/shangchangongdan/saveOrUpdate',
        data: {
          form_data: this.$util.deepCopy(this.selfData)
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
